import { RequestPurposeType } from "../../shared/services/request-purpose.service";
var ExperimentDesignShowHideService = /** @class */ (function () {
    function ExperimentDesignShowHideService() {
    }
    Object.defineProperty(ExperimentDesignShowHideService.prototype, "treatments", {
        get: function () { return this.experimentDesignFormGroup.get("treatments"); },
        enumerable: true,
        configurable: true
    });
    ;
    ExperimentDesignShowHideService.prototype.plantsToPots = function (treatment) { return treatment.get("plantingInstructions.numberToPots"); };
    ;
    ExperimentDesignShowHideService.prototype.plantsToHarvest = function (treatment) { return treatment.get("plantingInstructions.numberToHarvest"); };
    ;
    ExperimentDesignShowHideService.prototype.pottingInstructions = function (treatment) { return treatment.get("pottingInstructions"); };
    ;
    Object.defineProperty(ExperimentDesignShowHideService.prototype, "pollinationInstructions", {
        get: function () { return this.experimentDesignFormGroup.get("pollinationInstructions"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ExperimentDesignShowHideService.prototype, "harvestInstructions", {
        get: function () { return this.experimentDesignFormGroup.get("harvestInstructions"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ExperimentDesignShowHideService.prototype, "seedsToReturn", {
        get: function () { return this.experimentDesignFormGroup.get("harvestInstructions.minimumSeedsToReturn"); },
        enumerable: true,
        configurable: true
    });
    ;
    ExperimentDesignShowHideService.prototype.updateView = function (experimentDesignFormGroup, requestPurpose) {
        this.experimentDesignFormGroup = experimentDesignFormGroup;
        switch (requestPurpose) {
            case RequestPurposeType.BiomassInFlats: {
                this.biomassInFlats();
                break;
            }
            case RequestPurposeType.BiomassInPots: {
                this.biomassInPots();
                break;
            }
            case RequestPurposeType.PollinationAndImmatureHarvest: {
                this.pollinationAndImmatureHarvest();
                break;
            }
            case RequestPurposeType.Donors: {
                this.donors();
                break;
            }
            default: {
                break;
            }
        }
        this.experimentDesignFormGroup.updateValueAndValidity();
    };
    ExperimentDesignShowHideService.prototype.biomassInFlats = function () {
        this.disablePlantsToPots();
        this.disablePlantsToHarvest();
        this.disablePottingInstructions();
        this.disablePollinationInstructions();
        this.disableHarvestInstructions();
    };
    ExperimentDesignShowHideService.prototype.biomassInPots = function () {
        this.disablePlantsToHarvest();
        this.disablePollinationInstructions();
        this.disableHarvestInstructions();
    };
    ExperimentDesignShowHideService.prototype.pollinationAndImmatureHarvest = function () {
        this.disableSeedsToReturn();
    };
    ExperimentDesignShowHideService.prototype.donors = function () {
        this.disablePollinationInstructions();
    };
    ExperimentDesignShowHideService.prototype.disablePlantsToPots = function () {
        for (var _i = 0, _a = this.treatments.controls; _i < _a.length; _i++) {
            var treatment = _a[_i];
            this.plantsToPots(treatment).disable();
        }
        ;
    };
    ExperimentDesignShowHideService.prototype.disablePlantsToHarvest = function () {
        for (var _i = 0, _a = this.treatments.controls; _i < _a.length; _i++) {
            var treatment = _a[_i];
            this.plantsToHarvest(treatment).disable();
        }
        ;
    };
    ExperimentDesignShowHideService.prototype.disablePottingInstructions = function () {
        for (var _i = 0, _a = this.treatments.controls; _i < _a.length; _i++) {
            var treatment = _a[_i];
            this.pottingInstructions(treatment).disable();
        }
        ;
    };
    ExperimentDesignShowHideService.prototype.disablePollinationInstructions = function () {
        this.pollinationInstructions.disable();
    };
    ExperimentDesignShowHideService.prototype.disableHarvestInstructions = function () {
        this.harvestInstructions.disable();
    };
    ExperimentDesignShowHideService.prototype.disableSeedsToReturn = function () {
        this.seedsToReturn.disable();
    };
    return ExperimentDesignShowHideService;
}());
export { ExperimentDesignShowHideService };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/services/experiment-design-show-hide.service.ts.pre-build-optimizer.js